import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../config"; // Ruta corregida

const EstablecerPassword = () => {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState("");
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            setMessage("Las contraseñas no coinciden.");
            return;
        }

        try {
            const merchantId = searchParams.get("merchant_id");
            const email = searchParams.get("email");

            if (!merchantId || !email) {
                setMessage("Faltan parámetros en el enlace.");
                return;
            }

            const response = await fetch(`${API_BASE_URL}/establecer-password`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ merchant_id: merchantId, email, new_password: password }),
            });

            const data = await response.json();

            if (response.ok) {
                // Guardar el token y redirigir según el rol
                localStorage.setItem("token", data.token);
                localStorage.setItem("cliente_id", data.cliente_id);
                localStorage.setItem("merchant_id", data.merchant_id);
                localStorage.setItem("is_superadmin", data.is_superadmin);

                // Redirigir basado en el rol
                if (data.is_superadmin) {
                    navigate("/super-admin");
                } else {
                    navigate(`/dashboard/${data.cliente_id}`);
                }
            } else {
                setMessage(`Error: ${data.error}`);
            }
        } catch (error) {
            console.error("Error al enviar datos:", error);
            setMessage("Hubo un error al establecer la contraseña.");
        }
    };

    return (
        <div className="min-h-screen flex flex-col justify-center items-center bg-gray-100">
            <h2 className="text-2xl font-bold mb-4">Establecer Contraseña</h2>
            {message && <p className={`mb-4 ${message.includes("Error") ? "text-red-500" : "text-green-500"}`}>{message}</p>}
            <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow-md w-96">
                <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-700">Nueva Contraseña:</label>
                <input
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="block w-full px-3 py-2 mb-4 border rounded focus:ring focus:ring-blue-200"
                    required
                />

                <label htmlFor="confirmPassword" className="block mb-2 text-sm font-medium text-gray-700">Confirmar Contraseña:</label>
                <input
                    type="password"
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className="block w-full px-3 py-2 mb-4 border rounded focus:ring focus:ring-blue-200"
                    required
                />

                <button type="submit" className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 transition">
                    Establecer Contraseña
                </button>
            </form>
        </div>
    );
};

export default EstablecerPassword;
